import essLocalApi from '../axios/esspLocalApi';

class ProductService {

    async getProducts() {
        return Promise.resolve(essLocalApi.get(`products.json`));
    }

    async getTemplate() {
        return Promise.resolve(essLocalApi.get(`zpl.txt`));
    }


}

export default ProductService;